<template>
  <article>
    <h1>sail game engine</h1>
    <section>
      Sail is my C++ <span class="red">game engine</span> developed and maintained as a hobby project.
      <p>More information and source can be found at the <a href="https://github.com/Piratkopia13/Sail" target="_blank">GitHub repo</a>.
      <br>The engine is fully open source and published under the MIT license.</p>
      <p>
        Below is my internal development board showing current progress in no particular order.
        Some or all features listed below will probably not make much sense to anyone but me.
        The board is mainly here for the curious ones and because I wanted an excuse to use the <a href="https://coda.io">Coda.io</a> API.
      </p>
    </section>
    <br>
    <section>
      <h2 class="inside-title">Dev board</h2>
      <template v-if="data.status === 'Loading'">
        <span style="margin-left: 20px">Loading...</span>
      </template>
      <transition-group name="slide-fade">
        <template v-if="data.status === 'OK'">
          <template v-if="data.notes">
            <p style="margin-left: 20px" v-for="(note, i) in data.notes" :key="'note'+i">{{ note }}</p>
          </template>
          <div id="flex" :key="'divFlex'">
            <div id="column" v-for="(col, i) in data.data" :key="'col'+i" :data-title="col.name">
              <h2>{{ col.name }}</h2>
              <ul>
                <li v-for="(item, j) in col.items" :key="j">
                  <p><span class="title">{{ item.Name }}</span></p>
                  <p><span class="desc">{{ item.Description }}</span></p>
                  <p><span title="Priority" class="prio">{{ item.Priority }}</span></p>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </transition-group>
    </section>
    <br>
    <!-- Raw response:
    <p>{{ data }}</p> -->
  </article>
</template>

<script>

const codaApiWrapper = 'api_wrapper.php'
const axios = require('axios')

export default {
  name: 'Sail',

  data () {
    return {
      data: {
        status: 'Loading',
        data: [],
        notes: []
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {
    fetchData () {
      // Get feature table data
      axios
        .get(codaApiWrapper, {
          params: {
            dostuff: true
          }
        })
        .then(response => {
          const columns = []

          // Returns the index of 'columns' where the category matches
          // Creates a new column if the category doesnt exist
          const findColIndex = function (category) {
            let index = -1
            columns.some(function (val, i) {
              if (val.name === category) {
                index = i
                return true // Break look
              }
              return false // Keep looping
            })
            if (index === -1) {
              // Insert new category
              index = columns.push({
                name: category,
                items: []
              }) - 1
            }
            return index
          }

          // Add each item to the right column
          response.data.items.forEach(function (item, index) {
            const i = findColIndex(item.values.Category)
            delete item.values.Category // Remove duplicate value
            columns[i].items.push(item.values)
          })

          this.data.data = columns
          this.data.status = 'OK'
        })
        .catch(error => console.log(error))

      // Get note
      axios
        .get(codaApiWrapper, {
          params: {
            dostuff: true,
            note: true
          }
        })
        .then(response => {
          const notes = []
          response.data.items.forEach(function (item, index) {
            notes.push(item.values.Note)
          })
          this.data.notes = notes
        })
        .catch(error => console.log(error))
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../variables.scss';

h2 {
  margin: 0;
}
ul {
  padding-inline-start: 0;
  list-style: none;
  // list-style-position: inside;
  text-align: center;
}

li {
  background-color: $white;
  margin: 10px;
  border-radius: 2px;
  padding: 10px 15px;
  font-size: 0.8em;
}
li:hover {
  background-color: #EEEAEE;
}
li p {
  margin: 5px 0px;
}
li .title {
  font-weight: bold;
  display: inline-block;
}
li .desc {
  font-style: italic;
  display: inline;
}
li .prio {
  color: $red;
  font-size: 0.7em;
  display: inline-block;
  cursor: help;
}

.inside-title {
  margin-top: -40px;
  padding-left: 20px;
  font-size: 2.5em;
}

#flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

#column {
  background-color: #efefef;
  border-radius: 2px;
  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.5);
  padding: 20px 5px;
  margin: 20px;
  width: 305px;
  vertical-align: top;
  display: inline-block;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  flex-grow: 1;
  max-width: 500px;
}

// Ordering
#column[data-title="Idea"] {
  order: 0;
}
#column[data-title="To be implemented"] {
  order: 1;
}
#column[data-title="Being implemented"] {
  order: 2;
}
#column[data-title="Needs testing"] {
  order: 3;
}
#column[data-title="Fully implemented"] {
  order: 4;
}

#column:hover {
  background-color: #dcdcdc;
}
#column h2 {
  text-align: center;
}

</style>
